import { Platform } from 'react-native';

export type DvLoginAction =
  | 'login' | 'logout' | 'change_credentials' | 'remember_credentials' | 'account_creation' | 'set_biometric';
export type DvLoginMethod =
  | 'auto_cookie' | 'auto_token' | 'auto_he' | 'auto_sid' | 'manual' | 'manual_google' | 'manual_facebook' | 'manual_appleconnect' | 'biometric' | 'otp' | 'manual_otp';
export type DvLoginStatus = 'ok' | 'ko';
export type DvLoginType = 'email' | 'msisdn' | 'login' | 'null';

export type DvLoginEvent = {
  type_of_action: DvLoginAction;
  method: DvLoginMethod;
  status: DvLoginStatus;
  type?: DvLoginType;
  marketing_consent?: boolean | null;
  marketing_consent_shown?: boolean;
};

export interface Tracking {
  initTracking: (countryCode?: string | null) => Promise<void>;
  trackDvLogin: (payload: DvLoginEvent, contextEntities?: Array<{ schema: string; data: unknown }>) => Promise<void>;
  setUserId: (userId: string | null) => Promise<void>;
  trackPageView: (pageName: string, pageUrl?: string) => Promise<void>;
}

// Platform switch
const platformTracking = Platform.OS === 'web'
  ? require('./web').tracking
  : require('./native').tracking;

export const { initTracking, trackDvLogin, setUserId } = platformTracking;

// Export trackPageView separately since it's not part of the Tracking interface yet
export const trackPageView = Platform.OS === 'web'
  ? require('./web').trackPageView
  : require('./native').trackPageView;

// Export video tracking functions
export { setDvProductContext, trackVidStart, clearDvProductContext } from './video';
export type { DvProductCtx } from './video';

// Export Facebook tracking functions
export {
  initializeFacebookSdk,
  trackAppActivation,
  trackAppFirstOpen,
  trackCustomEvent as trackFacebookCustomEvent,
  setUserId as setFacebookUserId,
} from './facebookTracking';

// Export user interaction tracking functions
export {
  trackUserInteraction,
  trackAddToFavorites,
  trackRemoveFromFavorites,
  trackEarnCoins,
  trackSpendCoins,
  trackPaywallOpen,
  trackPaywallClose,
  trackPaywallProductClick,
  trackPurchaseInitiated,
  trackPurchaseSuccess,
  trackPurchaseCancel,
  trackPurchaseFailed,
  trackRestorePurchases,
  trackPaywallLearnMore,
  trackSearchOpen,
  trackSearchClose,
  trackSearchQuery,
  trackSearchResultClick,
  trackRubriqueClick,
  trackGamificationIntroOpen,
  trackGamificationIntroAction,
  trackEpisodeModalOpen,
  trackEpisodeModalClose,
  trackEpisodeModalTabClick,
  trackRatingPromptShown,
  trackRatingPromptResult,
} from './userInteraction';
export type {
  InteractionElementContext,
  UserInteractionEvent,
  PaywallSource,
  PaywallDismissMethod,
  PaywallProductInfo,
  SearchSource,
  SearchResultType,
  GamificationIntroAction,
  EpisodeModalTab,
  RatingPromptMilestone,
} from './userInteraction';